var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-panel"},[_c('div',{staticClass:"el-panel_header"},[_vm._v(_vm._s(_vm.title))]),_c('transition',{attrs:{"name":"el-zoom-in-top"}},[_c('div',{staticClass:"el-panel_content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }